export enum SampleRatio {
  ON = 0,
  OFF = 1,
}
